import React, { ChangeEvent } from "react";
import { CandybarItemType } from "./types";
import CandybarConfigPanel from "./CandybarConfigPanel";
import styled from "styled-components";

const Box = styled.textarea`
    background: var(--page-bg);
    border: 1px solid var(--text-primary);
    color: var(--text-primary);
    margin: 0;
    padding: 1em;
    width: 100%;

    &:focus {
        outline: none;
    }
`;

interface Props {
    item: CandybarItemType,
    comments: string,
    onChange: Function,
}

class CandybarItemComments extends React.Component<Props> {

    render() {
        const {comments} = this.props;

        return <CandybarConfigPanel
            bigTitle
            mandatory={false}
            name="Comentarios"
            summary={comments}
        >
            <Box onChange={(e:ChangeEvent<HTMLTextAreaElement>) => this.props.onChange(e.target.value)} value={comments}/>
        </CandybarConfigPanel>;
    }
}

export default CandybarItemComments;